import { Field, RichText, Text } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from 'lib/ComponentProps';

import IsSitecoreEditing from 'src/utils/isSitecoreEditing';

import styles from './MembershipPricingTable.module.css';

type MembershipPricingTableProps = ComponentProps & {
	fields: {
		Header: Field<string>;
		SubHeader: Field<string>;
		PricingTable: Field<string>;
		Notes: Field<string>;
	};
};

export default function MembershipPricingTable(props: MembershipPricingTableProps): JSX.Element {
	const isEditing = IsSitecoreEditing();

	if (!isEditing && !props.fields) {
		return <></>;
	}

	return (
		<section className="maxWidth padX padYL">
			<div className={styles.membershipPricingTableContainer}>
				<div className={styles.headerContainer}>
					<Text tag="h1" field={props.fields.Header} className={styles.Header} />
					<Text tag="h2" field={props.fields.SubHeader} className={styles.subHeader} />
				</div>
				<RichText field={props.fields.PricingTable} className={styles.membershipPricingTable} />
				<RichText field={props.fields.Notes} className={styles.notes} />
			</div>
		</section>
	);
}
